(function () {
  'use strict';
  if (window.__aonicCareBound) return;
  window.__aonicCareBound = true;

  // AONIC Care+ add-on. Loaded globally (like shipping-protection.js) so it always
  // runs, even with the theme's view-transition page navigation. Toggling writes
  // Care+ to the cart, then fires the SAME 'cart:update' (CartUpdateEvent) that
  // Horizon fires after any native cart change — so Horizon AND the free-gift /
  // bundle app re-sync their state. The plain Care+ line item is hidden via CSS.

  var pendingCartOp = null;

  function careVariant() {
    var cb = document.getElementById('care-toggle-checkbox');
    return cb ? cb.dataset.variantId : null;
  }

  function paintTotal(cents) {
    var amount = cents / 100;
    var hasCents = (Math.round(cents) % 100) !== 0;
    var num;
    try { num = amount.toLocaleString(undefined, { minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: 2 }); }
    catch (e) { num = hasCents ? amount.toFixed(2) : String(Math.round(amount)); }
    var totals = document.querySelectorAll('.cart__checkout-total, [data-cart-subtotal], .cart-totals__total-value');
    for (var i = 0; i < totals.length; i++) {
      var el = totals[i];
      var current = (el.getAttribute('value') || el.textContent || '').trim();
      var m = current.match(/^([^0-9]*)([0-9.,\s]*[0-9])?(.*)$/);
      var formatted = (m ? m[1] : '') + num + (m ? (m[3] || '') : '');
      el.textContent = formatted;
      if (el.tagName === 'TEXT-COMPONENT') el.setAttribute('value', formatted);
    }
  }

  function paintBubble(count) {
    var nodes = document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]');
    for (var k = 0; k < nodes.length; k++) nodes[k].textContent = count;
  }

  function notifyCart(cart, sid) {
    var ci = document.querySelector('cart-items-component');
    if (!ci || !sid || !cart.sections) return;
    var ev;
    try {
      ev = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'aonic-care-addon',
          data: { itemCount: cart.item_count, source: 'aonic-care', sections: cart.sections }
        }
      });
    } catch (e) { return; }
    ci.dispatchEvent(ev);
  }

  function careWrite(want) {
    var vid = careVariant();
    if (!vid) return Promise.resolve();
    var ci = document.querySelector('cart-items-component');
    var sid = ci ? ci.dataset.sectionId : null;
    var updates = {}; updates[vid] = want ? 1 : 0;
    var body = { updates: updates };
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) {
        paintTotal(cart.total_price);
        paintBubble(cart.item_count);
        notifyCart(cart, sid);
        return cart;
      });
  }

  function setLoading(on) {
    var w = document.getElementById('aonic-care-addon');
    if (w) w.classList.toggle('sp-widget--loading', on);
  }

  function onToggle(checkbox) {
    var want = checkbox.checked;
    setLoading(true);
    var op = careWrite(want)
      .catch(function () { var c = document.getElementById('care-toggle-checkbox'); if (c) c.checked = !want; })
      .then(function () { setLoading(false); if (pendingCartOp === op) pendingCartOp = null; });
    pendingCartOp = op;
    return op;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'care-toggle-checkbox') return;
    onToggle(t);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('#checkout, button[name="checkout"], .cart__checkout-button') : null;
    if (!btn) return;
    if (btn.dataset.careGo) { delete btn.dataset.careGo; return; }
    if (!pendingCartOp) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    pendingCartOp.then(function () { btn.removeAttribute('aria-busy'); btn.dataset.careGo = '1'; btn.click(); });
  }, true);

  // =====================================================================
  // INSTANT CART DRAWER
  // The free-gift app makes /cart/add.js slow (~3-4s), and the theme only
  // opens the drawer AFTER the add finishes — shoppers stare at the PDP for
  // several seconds. Open the drawer immediately on the add click and show a
  // spinner; the real contents fill in when the cart finishes updating.
  // =====================================================================
  var loaderStyleAdded = false;
  function ensureLoaderStyle() {
    if (loaderStyleAdded) return; loaderStyleAdded = true;
    var s = document.createElement('style');
    s.textContent =
      '.aonic-cart-loading .cart-drawer__inner{position:relative;}' +
      '.aonic-cart-spinner{position:absolute;inset:0;z-index:30;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.55);}' +
      '.aonic-cart-spinner::after{content:"";width:34px;height:34px;border-radius:50%;border:3px solid rgba(0,0,0,0.15);border-top-color:#0a0a0a;animation:aonicspin .7s linear infinite;}' +
      '@keyframes aonicspin{to{transform:rotate(360deg);}}';
    document.head.appendChild(s);
  }
  function clearCartLoader() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    drawer.classList.remove('aonic-cart-loading');
    var sp = drawer.querySelectorAll('.aonic-cart-spinner');
    for (var i = 0; i < sp.length; i++) sp[i].remove();
  }
  function openCartInstant() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;
    ensureLoaderStyle();
    var inner = drawer.querySelector('.cart-drawer__inner');
    if (inner) {
      drawer.classList.add('aonic-cart-loading');
      if (!inner.querySelector('.aonic-cart-spinner')) {
        var sp = document.createElement('div'); sp.className = 'aonic-cart-spinner'; inner.appendChild(sp);
      }
    }
    // Defer the open one tick so the current click can't immediately dismiss the dialog.
    setTimeout(function () { try { drawer.open(); } catch (e) {} }, 0);
    clearTimeout(window.__aonicLoaderTimer);
    window.__aonicLoaderTimer = setTimeout(clearCartLoader, 9000);
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('.add-to-cart-button, button[name="add"]') : null;
    if (!add) return;
    if (add.closest('cart-items-component')) return;   // ignore qty controls inside the cart
    openCartInstant();
  }, true);
  // When the cart actually updates, drop the spinner so the fresh contents show.
  document.addEventListener('cart:update', function () { setTimeout(clearCartLoader, 50); }, true);
  document.addEventListener('cart:add', function () { setTimeout(clearCartLoader, 50); }, true);
})();
